import { getDefaultConfig } from 'connectkit';
import { createConfig, http } from 'wagmi';
import { holesky, mainnet, sepolia, taikoHekla } from 'wagmi/chains';

export const wagmiConfig = createConfig(
  getDefaultConfig({
    appName: 'Relend',
    appIcon: 'https://relend.app/logo.png',
    appDescription: 'Relend',
    appUrl: 'https://relend.app',
    walletConnectProjectId: 'f164c696648675f9b172a90df99ac679',
    chains: [mainnet, sepolia, taikoHekla, holesky],
    transports: {
      [mainnet.id]: http(),
      [sepolia.id]: http(),
      [taikoHekla.id]: http(),
      [holesky.id]: http()
    }
  })
);
